import React, { useMemo, useCallback, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import classnames from "classnames";
import { getSubUsers } from "services/usersServices";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import Loader from "components/Loader";
import Pagination from "components/common/Pagination";
import moment from "moment";
const { success, error, fetching } = NavigationActions;

let debounceTimer;

const HeaderComponent = props => {
  let classes = {
    "-sort-asc": props.isSortedDesc !== undefined && !props.isSortedDesc,
    "-sort-desc": props.isSortedDesc !== undefined && props.isSortedDesc
  };
  return <div className={classnames(classes)}>{props.title}</div>;
};

function CallLogs(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const pageLength = 10;
  const [totalPage, setTotalPage] = useState(0);
  const [sortObject, setSortObject] = useState({ id: "id", desc: false });
  const { token, error, fetching, user } = props;
  const [refresh, toggleRefresh] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState("0");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Sr No."
            />
          );
        },
        placeholder: "",
        disableFilters: true,
        accessor: "id",

        Cell: tableInstance => {
          return tableInstance.row.index + 1 + currentPage * pageLength;
        }
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Full Name"
            />
          );
        },
        placeholder: "Full Name",
        disableFilters: true,
        accessor: "name",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row.values.name}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Email"
            />
          );
        },
        placeholder: "Email",
        disableFilters: true,
        accessor: "email"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Mobile No"
            />
          );
        },
        placeholder: "Mobile",
        disableFilters: true,
        accessor: "phone_number"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Date of Onboarding"
            />
          );
        },
        placeholder: "Date of onboarding",
        disableFilters: true,
        accessor: "createdAt",
        Cell: tableInstance => {
          return (
            <span className="text-capitalize">
              {moment(tableInstance.row.original.createdAt).format(
                "DD MMM YYYY"
              )}
            </span>
          );
        }
      },

      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Action"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "Action",
        Cell: tableInstance => (
          <div className="react-action-class">
            <button
              className="react-table-edit-button"
              onClick={() => {
                props.history.push(
                  `/user-logs/${tableInstance.row.values.id}/${tableInstance.row.values.name}`
                );
              }}
            >
              View Logs
            </button>
          </div>
        )
      }
    ],
    [currentPage]
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    rows,
    headerGroups,
    state: { sortBy }
  } = useTable(
    {
      data: usersList,
      columns: columns,
      manualSortBy: true,
      initialState: {
        pageSize: pageLength,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );

  const callApi = useCallback(async () => {
    let params = {
      page_number: currentPage + 1,
      limit: pageLength || 10,
      sortBy: sortObject?.id,
      sortOrder:
        sortObject.desc !== undefined
          ? sortObject.desc
            ? "desc"
            : "asc"
          : "desc",
      search: searchText
    };
    await getSubUsers(token, user._id, { params: params }).then(response => {
      if (response.success) {
        setUsersList(response.data.docs);
        setTotalRecords(response.data.totalDocs);
        setTotalPage(response.data.totalPages);
        setLoading(false);
        toggleRefresh(false);
      } else {
        error(response.message);
      }
    });
  });

  useEffect(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    debounceTimer = setTimeout(() => {
      callApi();
    }, 1000);
  }, [searchText]);

  useEffect(() => {
    refresh && callApi();
  }, [refresh, currentPage, sortBy, pageLength]);

  useEffect(() => {
    setSortObject({ ...sortBy[0] });
    toggleRefresh(true);
  }, [sortBy]);

  const handlePageChange = page => {
    fetching();
    setCurrentPage(page);
    toggleRefresh(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row title-sec align-items-center">
          <div className="col-sm headline">Call Logs</div>
          <div className="col-auto "></div>
        </div>
        <div className="row align-items-center my-3">
          <div className="col-md-4">
            <div className="icon-form-control">
              <i class="fas fa-search"></i>
              <input
                value={searchText}
                onChange={e => {
                  setCurrentPage(0);
                  setSearchText(e.target.value);
                }}
                type="text"
                placeholder="Search users..."
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
        </div>
        <div className="div-container">
          <ReactTableWrapper {...props}>
            <div className="table-responsive common-table card-box grey-box mb-2">
              <table className="table border-0" {...getTableProps()}>
                <thead className="thead-color text-center">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(header => (
                        <th
                          className="thead-color"
                          {...header.getHeaderProps(
                            header.getSortByToggleProps()
                          )}
                        >
                          <div>{header.render("Header")}</div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="text-center">
                  {loading ? (
                    <tr>
                      <td colSpan={4}>
                        <Loader colspan={columns?.length} />
                      </td>
                    </tr>
                  ) : rows.length > 0 ? (
                    rows.map(row => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <td className="td-border" {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="td-border" colSpan={columns?.length}>
                        <h6>No Data Found</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row align-items-center table-footer">
              <div className="col-sm-6 text-center text-sm-left">
                <span className="total-entry">
                  Showing{" "}
                  {Math.min(
                    currentPage * pageLength + usersList.length,
                    totalRecords
                  )}{" "}
                  of {totalRecords} entries
                </span>
              </div>
              <div className="col-sm-6">
                <Pagination
                  onPageChange={handlePageChange}
                  pages={totalPage}
                  page={currentPage}
                />
              </div>
            </div>
          </ReactTableWrapper>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(CallLogs);
